<template>
  <div>
    <link href="https://fonts.googleapis.com/css?family=Montserrat:100,200,400&display=swap" rel="stylesheet">
    <Navigation></Navigation>
    <Errors></Errors>
    <router-view></router-view>
  </div>
</template>

<script>
import Navigation from '@/components/Stock/Navigation'
import Errors from '@/components/Stock/Errors'

export default {
  name: 'App',
  components: {
    'Navigation': Navigation,
    'Errors': Errors
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue